var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricCellDurationText, widgetMetricTableColMetricPeriodDiffLeanStyle, widgetMetricTableColMetricValueStyle, widgetMetricTableDurationSlashClass, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, getApplicationIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToChartDestination } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
var communicationByPeerTypeCountDurationRowFitClass = 'inline-flex w-fit max-w-full min-w-0 flex-nowrap items-baseline justify-start gap-x-1 pl-0 pr-0';
var peerTypeLabelMetricTrioWithTeam = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffLeanStyle,
    {}
];
var peerTypeLabelMetricPairNoTeam = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffLeanStyle
];
function communicationByPeerTypeTableColgroup(includeTeamDiffColumn) {
    if (includeTeamDiffColumn) {
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            { width: '18%', minWidth: '9rem' }
        ], peerTypeLabelMetricTrioWithTeam, true), peerTypeLabelMetricTrioWithTeam, true), peerTypeLabelMetricTrioWithTeam, true), peerTypeLabelMetricTrioWithTeam, true);
    }
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        { width: '24%', minWidth: '10rem' }
    ], peerTypeLabelMetricPairNoTeam, true), peerTypeLabelMetricPairNoTeam, true), peerTypeLabelMetricPairNoTeam, true), peerTypeLabelMetricPairNoTeam, true);
}
export var CommunicationByPeerTypeSection = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = trpc.communicationByPeerType.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), peerTypeData = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    var metricHeaderColspan = 3;
    var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var columns = [
        {
            title: (_jsx("div", __assign({ className: "flex items-center gap-2" }, { children: _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.peerType') }) }))),
            isVisible: true,
            className: 'min-w-0 !text-left !pl-3'
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getApplicationIconByType(ApplicationEnum.GMAIL), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getApplicationIconByType(ApplicationEnum.CHAT), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.googleChatMessages') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getApplicationIconByType(ApplicationEnum.MEET), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.meetings') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getApplicationIconByType(ApplicationEnum.DRIVE), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.documentcomments') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        }
    ];
    var navigateToEventsLog = function (app) {
        if (app === void 0) { app = null; }
        navigateToChartDestination({ kind: 'eventsLog', app: app }, {
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var renderRow = function (row) {
        var rowKey = String(row.peerType);
        var meetData = row.meetings;
        var durationText = (meetData === null || meetData === void 0 ? void 0 : meetData.duration) ? String(meetData.duration) : '';
        var meetingsMetricCells = [
            {
                id: "meetings-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsxs("div", __assign({ className: classNames(communicationByPeerTypeCountDurationRowFitClass, 'cursor-pointer'), onClick: function () { return navigateToEventsLog(ApplicationEnum.MEET); } }, { children: [_jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: (meetData === null || meetData === void 0 ? void 0 : meetData.count) || 0 })), _jsx("span", __assign({ className: widgetMetricTableDurationSlashClass, "aria-hidden": "true" }, { children: "/" })), _jsx("span", __assign({ className: widgetMetricCellDurationText }, { children: durationText }))] }))); }
            },
            metricTablePeriodDiffRowCell("meetings-period-".concat(rowKey), meetData === null || meetData === void 0 ? void 0 : meetData.userDiff, TablesDiffColorsConfig.GREEN, widgetMetricTablePeriodDiffBeforeTeamTdClass, { innerJustify: 'end' }),
            metricTableTeamAvgDiffRowCell("meetings-team-".concat(rowKey), meetData === null || meetData === void 0 ? void 0 : meetData.orgUnitAvgDiff, isSecondaryDiffHidden)
        ];
        var driveData = row.drive;
        var driveMetricCells = [
            {
                id: "documents-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: function () { return navigateToEventsLog(ApplicationEnum.DRIVE); } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: (driveData === null || driveData === void 0 ? void 0 : driveData.count) || 0 })) }))); }
            },
            metricTablePeriodDiffRowCell("documents-period-".concat(rowKey), driveData === null || driveData === void 0 ? void 0 : driveData.userDiff, TablesDiffColorsConfig.GREEN, widgetMetricTablePeriodDiffBeforeTeamTdClass, { innerJustify: 'end' }),
            metricTableTeamAvgDiffRowCell("documents-team-".concat(rowKey), driveData === null || driveData === void 0 ? void 0 : driveData.orgUnitAvgDiff, isSecondaryDiffHidden)
        ];
        var chatData = row.chat;
        var chatMetricCells = [
            {
                id: "chat-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: function () { return navigateToEventsLog(ApplicationEnum.CHAT); } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: (chatData === null || chatData === void 0 ? void 0 : chatData.count) || 0 })) }))); }
            },
            metricTablePeriodDiffRowCell("chat-period-".concat(rowKey), chatData === null || chatData === void 0 ? void 0 : chatData.userDiff, TablesDiffColorsConfig.GREEN, widgetMetricTablePeriodDiffBeforeTeamTdClass, { innerJustify: 'end' }),
            metricTableTeamAvgDiffRowCell("chat-team-".concat(rowKey), chatData === null || chatData === void 0 ? void 0 : chatData.orgUnitAvgDiff, isSecondaryDiffHidden)
        ];
        var gmailData = row.gmail;
        var gmailMetricCells = [
            {
                id: "gmail-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: function () { return navigateToEventsLog(ApplicationEnum.GMAIL); } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: (gmailData === null || gmailData === void 0 ? void 0 : gmailData.count) || 0 })) }))); }
            },
            metricTablePeriodDiffRowCell("gmail-period-".concat(rowKey), gmailData === null || gmailData === void 0 ? void 0 : gmailData.userDiff, TablesDiffColorsConfig.GREEN, widgetMetricTablePeriodDiffBeforeTeamTdClass, { innerJustify: 'end' }),
            metricTableTeamAvgDiffRowCell("gmail-team-".concat(rowKey), gmailData === null || gmailData === void 0 ? void 0 : gmailData.orgUnitAvgDiff, isSecondaryDiffHidden)
        ];
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            {
                id: "peerType-".concat(rowKey),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer font-semibold break-words", onClick: function () { return navigateToEventsLog(); } }, { children: row.peerType }))); }
            }
        ], gmailMetricCells, true), chatMetricCells, true), meetingsMetricCells, true), driveMetricCells, true);
    };
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var tableData = (peerTypeData !== null && peerTypeData !== void 0 ? peerTypeData : []).map(function (peerTypeRow) {
        return renderRow(peerTypeRow);
    });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.communicationByPeerType'), description: t('widgetTitleDescriptions.communication.userCommunicationByPeerType'), insightType: InsightTypeEnum.communicationByPeerType, insightsData: peerTypeData || [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.communicationByPeerType'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (peerTypeData !== null && peerTypeData !== void 0 ? peerTypeData : []).map(function (item) {
                                    var _a;
                                    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.peerType')] = item.peerType,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails')] = (_c = (_b = item.gmail) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : 0,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.googleChatMessages')] = (_e = (_d = item.chat) === null || _d === void 0 ? void 0 : _d.count) !== null && _e !== void 0 ? _e : 0,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.meetings')] = (_g = (_f = item.meetings) === null || _f === void 0 ? void 0 : _f.count) !== null && _g !== void 0 ? _g : 0,
                                        _a[t('app.apps.searchMeetings.filters.duration')] = (_h = item.meetings) === null || _h === void 0 ? void 0 : _h.duration,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.documentcomments')] = (_k = (_j = item.drive) === null || _j === void 0 ? void 0 : _j.count) !== null && _k !== void 0 ? _k : 0,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(peerTypeData !== null && peerTypeData !== void 0 ? peerTypeData : []) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(peerTypeData !== null && peerTypeData !== void 0 ? peerTypeData : []) ? [] : tableData, columnColStyles: communicationByPeerTypeTableColgroup(true), tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top" })] })));
};
